import { mdiNewspaper } from '@lumapps/lumx/icons';
// Re-exported from the articles domain, which owns this id (avoids an articles -> widget-article-list dependency).
export { WIDGET_ARTICLE_LIST_TYPE } from '@lumapps/articles/constants';

export const WIDGET_ARTICLE_LIST_ICON = mdiNewspaper;

export const DATA_SCOPE = 'widget-article-list-settings';

export enum INFORMATION_DISPLAYED {
    AUTHOR = 'author',
    PUBLICATION_DATE = 'published_at',
    COMMUNITY_NAME = 'shares',
    TITLE = 'title',
    EXCERPT = 'intro',
    SOCIAL = 'reactions',
}

export enum SORTING_VALUES {
    OLDEST_TO_LATEST = 'asc',
    LATEST_TO_OLDEST = 'desc',
}
